import * as PIXI from 'pixi.js';
import { globalData } from './globalData.js';
import { config } from './appConfig.js';
import gsap from 'gsap';
import { betHistory, setLanguage } from './gameService.js';
import { formatBalance, gameAssets, instances, updateGameSpeed } from './gameUI.js';
import { playDisable, playMainBg, playMinus, playPlus, playPopUpClose, playtabChange, stopMainBg, stopSFX } from './soundManager.js';
import { gameStates } from './gameStates.js';

export class menuPopUp {

    backgroundBlur = null;
    menuPopUp = null;
    stopPos = null;
    prizePos = null

    settingsMenuInactive = null;
    tutorialMenuInactive = null;
    settingsMenuActive = null;
    tutorialMenuActive = null;
    closeButtonNormal = null;
    historyContainer = null;
    rows = [];
    betHistoryArrow1 = null;
    betHistoryArrow2 = null;
    betHistoryArrow3 = null;

    pageContainer = null
    size = null
    page = [];
    withJackpotEng = ['p1', 'p2', 'p3', 'p4', 'p4b', 'p4c', 'p5', 'p6', 'p7', 'p9', 'p10', 'p8.1', 'p8.2', 'p8.2'];
    withoutJackpotEng = ['p1', 'p2', 'p3', 'p4', 'p4b', 'p4c', 'p5', 'p6', 'p9', 'p10', 'p8.1', 'p8.2', 'p8.2'];
    withJackpotTag = [
        "p1_content_tag",
        "p2_content_tag",
        "p3_content_tag",
        "p4_content_tag",
        'p4b_content_tag', 'p4c_content_tag',
        "p5_content_tag",
        "p6_content_tag",
        "p7_content_tag",
        'p9_content_tag',
        'p10_content_tag',
        "p8_content01_tag",
        "p8_content02_tag",
        "p8_content03_tag",
    ];
    withoutJackpotTag = [
        "p1_content_tag",
        "p2_content_tag",
        "p3_content_tag",
        "p4_content_tag",
        'p4b_content_tag', 'p4c_content_tag',
        "p5_content_tag",
        "p6_content_tag",
        'p9_content_tag',
        'p10_content_tag',
        "p8_content01_tag",
        "p8_content02_tag",
        "p8_content03_tag",
    ]

    constructor() {
        this.menuPopUp = new PIXI.Container();
        this.historyContainer = new PIXI.Container();


        this.backgroundBlur = new PIXI.Graphics();
        this.backgroundBlur.beginFill(0, 0.8);
        this.backgroundBlur.drawRect(config.logicalWidth / 2 - 750, config.logicalHeight / 2 - 1600, 1500, 3500);
        this.backgroundBlur.endFill();
        this.backgroundBlur.interactive = false;
        this.menuPopUp.addChild(this.backgroundBlur);
        this.setupMenu();
        this.setupCloseButton();
        this.disable();
        this.enableSettingsMenu();
        this.setupHistoryHeader();
        this.setupHistorRows();
        this.setupHistoryArrows();
        this.betHistoryActive.addChild(this.historyContainer)
        //this.setDefaultLanguage(globalData.gameLanguage);
    }

    setupHistoryArrows() {
        this.betHistoryArrow1 = new PIXI.Sprite(PIXI.Assets.get('scrollArrow'));
        this.betHistoryArrow1.anchor.set(0.5);
        this.betHistoryArrow1.scale.set(2.9)
        this.betHistoryArrow1.y = 890
        this.betHistoryArrow1.interactive = true;
        this.betHistoryArrow1.cursor = 'pointer';

        this.betHistoryArrow2 = new PIXI.Sprite(PIXI.Assets.get('scrollArrow'));
        this.betHistoryArrow2.anchor.set(0.5);
        this.betHistoryArrow2.scale.set(2.9)
        this.betHistoryArrow2.x = 690;
        this.betHistoryArrow2.angle = -90;
        this.betHistoryArrow2.interactive = true;
        this.betHistoryArrow2.cursor = 'pointer';

        this.betHistoryArrow3 = new PIXI.Sprite(PIXI.Assets.get('scrollArrow'));
        this.betHistoryArrow3.anchor.set(0.5);
        this.betHistoryArrow3.scale.set(2.9)
        this.betHistoryArrow3.x = -690;
        this.betHistoryArrow3.angle = 90;
        this.betHistoryArrow3.interactive = true;
        this.betHistoryArrow3.cursor = 'pointer';

        this.betHistoryArrow2.on('pointerdown', () => {
            this.betHistoryArrow2.visible = false;
            this.betHistoryArrow1.visible = false;
            this.betHistoryArrow3.visible = false;
            globalData.horizontalScroll = true;
        })

        this.betHistoryArrow1.on('pointerdown', () => {
            this.betHistoryArrow1.visible = false;
            this.betHistoryArrow2.visible = false;
            this.betHistoryArrow3.visible = false;
            globalData.verticalScroll = true;
        })

        this.betHistoryArrow3.on('pointerdown', () => {
            this.betHistoryArrow1.visible = false;
            this.betHistoryArrow2.visible = false;
            this.betHistoryArrow3.visible = false;
            globalData.horizontalScrollLeft = true;
        })
        this.betHistoryActive.addChild(this.betHistoryArrow1, this.betHistoryArrow2, this.betHistoryArrow3);

        gsap.timeline({ repeat: -1, yoyo: true })
            .to([this.betHistoryArrow1, this.betHistoryArrow2, this.betHistoryArrow3], {
                pixi: {
                    scale: 3.5
                },
                duration: 0.3,
                ease: "power1.inOut",
            });
    }

    scrollHistoryVertical(delta) {
        this.historyRowContainer.y = this.historyRowContainer.y - 1.5 * delta;

        if (this.historyRowContainer.y < -715) {
            globalData.verticalScroll = false;
        }
    }

    scrollHistoryHorizontal(delta) {
        this.historyContainer.x = this.historyContainer.x - 1.5 * delta;

        if (this.historyContainer.x < -2056) {
            globalData.horizontalScroll = false;
        }
    }

    scrollHistoryLeftHorizontal(delta) {
        this.historyContainer.x = this.historyContainer.x + 1.5 * delta;

        if (this.historyContainer.x > 0) {
            globalData.horizontalScrollLeft = false;
        }
    }

    populateRows() {
        const style = new PIXI.TextStyle({
            fill: "#ffffff",
            fontFamily: "Arial",
            fontSize: 13,
            fontWeight: "bold",
            align: "center",
            dropShadow: true,
            dropShadowColor: "#000000",
            dropShadowBlur: 2,
            dropShadowAngle: Math.PI / 4,
            dropShadowDistance: 1,
            stroke: "#000000",
            strokeThickness: 0
        });

        const scaleOffset = 175;

        globalData.betHist.map((value, index) => {
            const { car_direction, bet_amount, result, date, time, obstacles_direction, beforebalance, afterbalance, winning_amount, prize_upgrade } = value;
            this.rows[index].removeChildren();
            const directionString = Array.isArray(car_direction) ? car_direction.join(',') : '';
            const objDirection = Array.isArray(obstacles_direction) ? obstacles_direction.join(',') : '';
            const before = formatBalance(beforebalance, 2)
            const after = formatBalance(afterbalance, 2)
            const newWin = formatBalance(winning_amount, 2)

            const text1 = new PIXI.Text(date, style);
            const text2 = new PIXI.Text(time, style);
            const text3 = new PIXI.Text(objDirection, style);
            const text4 = new PIXI.Text(directionString, style);
            const text5 = new PIXI.Text(bet_amount, style);
            const text6 = new PIXI.Text(before, style);
            const text7 = new PIXI.Text(after, style);
            const text8 = new PIXI.Text(newWin, style);
            const text9 = new PIXI.Text(result, style);
            const text10 = new PIXI.Text(prize_upgrade, style);

            text10.anchor.set(0.5);
            text9.anchor.set(0.5);
            text8.anchor.set(0.5);
            text7.anchor.set(0.5);
            text6.anchor.set(0.5);
            text5.anchor.set(0.5);
            text4.anchor.set(0.5);
            text3.anchor.set(0.5);
            text2.anchor.set(0.5);
            text1.anchor.set(0.5);

            // if(text4.width > scaleOffset){
            //     const scale = scaleOffset / text4.width                
            //     text4.scale.set(scale)
            // }
            //  if(text3.width > scaleOffset){
            //     const scale = (scaleOffset) / text3.width                
            //     text3.scale.set(scale)
            // }

            text1.scale.set(1, 1.5);
            text2.scale.set(1, 1.5);
            text3.scale.set(1, 1.4);

            text4.scale.set(1, 1.4);
            text5.scale.set(1, 1.4);
            text6.scale.set(1, 1.4);


            text7.scale.set(1, 1.4);
            text8.scale.set(1, 1.4);
            text9.scale.set(1, 1.4);
            text10.scale.set(1, 1.4);

            text1.x = 58;
            text2.x = 130
            text3.x = 240
            text4.x = 395;
            text5.x = 520;
            text6.x = 635;
            text7.x = 790;
            text8.x = 940
            text9.x = 1050
            text10.x = 1145;


            this.rows[index].addChild(text1, text2, text3, text4, text5, text6, text7, text8, text9, text10);
        });
    }

    setupHistorRows() {
        this.historyRowContainer = new PIXI.Container();
        this.historyContainer.addChild(this.historyRowContainer)
        this.historyRowContainer.y = -365;

        const width = this.historyHeaderContainer.width;

        this.mask1 = new PIXI.Sprite(PIXI.Assets.get('gameScreen'));
        this.mask1.anchor.set(0.5);
        this.mask1.scale.set(1.08);
        this.mask1.alpha = 1
        this.mask1.x = 0
        this.mask1.y = 215
        this.mask1.width = 1200
        this.betHistoryActive.addChild(this.mask1);

        this.historyRowContainer.mask = this.mask1;

        for (let i = 0; i < 10; i++) {
            this.rows[i] = new PIXI.Sprite(PIXI.Assets.get('history_row'));
            this.rows[i].anchor.set(0, 0.5);
            this.rows[i].y = i * 165;
            this.rows[i].x = -670;
            const r_width = this.rows[i].width;
            const scale = width / r_width;

            this.rows[i].scale.set(scale * 1.1, 1.7);

            this.historyRowContainer.addChild(this.rows[i]);
        }

        let dragging = false;
        let dragStartY = 0;
        let initialY = 0;

        this.historyRowContainer.interactive = true;
        this.historyRowContainer.cursor = 'grab';
        // this.historyRowContainer.eventMode = 'static'; 

        this.historyRowContainer.on('pointerdown', (event) => {

            dragging = true;
            dragStartY = event.global.y;
            initialY = this.historyRowContainer.y;
            this.historyRowContainer.cursor = 'grabbing';
        });

        this.historyRowContainer.on('pointerup', () => {
            dragging = false;
            this.historyRowContainer.cursor = 'grab';
        });

        this.historyRowContainer.on('pointerupoutside', () => {
            dragging = false;
            this.historyRowContainer.cursor = 'grab';
        });

        this.historyRowContainer.on('pointermove', (event) => {
            if (!dragging) return;

            const delta = event.global.y - dragStartY;
            let newY = initialY + delta;


            const maxY = -355;
            const minY = -305 - (165 * 10 - this.mask1.height);

            newY = Math.max(Math.min(newY, maxY), minY);
            this.historyRowContainer.y = newY;
            globalData.verticalScroll = false;

            if (this.historyRowContainer.y < -720) {
                this.betHistoryArrow1.visible = false;
            } else {
                this.betHistoryArrow1.visible = true;
            }
        });

        this.setupHorizontalScroll();

    }

    setupHorizontalScroll() {
        let dragging = false;
        let dragStartX = 0;
        let initialX = 0;
        this.historyContainer.interactive = true;

        this.historyContainer.cursor = 'grab';
        //   this.historyContainer.eventMode = 'static';

        this.historyContainer.on('pointerdown', (event) => {
            dragging = true;
            dragStartX = event.global.x;
            initialX = this.historyContainer.x;
            this.historyContainer.cursor = 'grabbing';
        });

        this.historyContainer.on('pointerup', () => {
            dragging = false;
            this.historyContainer.cursor = 'grab';
        });

        this.historyContainer.on('pointerupoutside', () => {
            dragging = false;
            this.historyContainer.cursor = 'grab';
        });

        this.historyContainer.on('pointermove', (event) => {
            if (!dragging) return;

            const deltaX = event.global.x - dragStartX;
            let newX = initialX + deltaX;


            const minX = -2060;
            const maxX = 5;

            this.historyContainer.x = Math.max(Math.min(newX, maxX), minX);
            globalData.verticalScroll = false;
            globalData.horizontalScroll = false;
            globalData.horizontalScrollLeft = false;

            if (this.historyContainer.x < -2055) {
                this.betHistoryArrow2.visible = false;
            } else {
                this.betHistoryArrow1.visible = true;
                this.betHistoryArrow2.visible = true;
            }

            if (this.historyContainer.x < 0) {
                this.betHistoryArrow3.visible = true;
            }
        });
    }

    setupHistoryHeader() {
        this.historyHeaderContainer = new PIXI.Container();
        this.historyHeaderContainer.x = 13;
        this.historyHeaderContainer.y = 40;

        this.mask2 = new PIXI.Sprite(PIXI.Assets.get('gameScreen'));
        this.mask2.anchor.set(0.5);
        this.mask2.scale.set(0.15);
        this.mask2.alpha = 1
        this.mask2.x = -5
        this.mask2.y = -560

        const style = new PIXI.TextStyle({
            fill: "#ffffff",
            fontFamily: "Arial",
            fontSize: 53,
            fontWeight: "bold",
            align: "center",
            dropShadow: true,
            dropShadowColor: "#000000",
            dropShadowBlur: 2,
            dropShadowAngle: Math.PI / 4,
            dropShadowDistance: 1,
            stroke: "#000000",
            strokeThickness: 0
        });

        let temp;
        let spacing = [-550, -325, 0, 415, 780, 1100, 1535, 1940, 2260, 2530]

        for (let i = 0; i < gameAssets.historyContent.length; i++) {
            const label = gameAssets.historyContent[i];

            const text = new PIXI.Text(label, style);
            text.anchor.set(0.5);

            text.x = spacing[i]

            if (i == 7 || i == 6 || i == 5 || i == 3 || i == 2) text.y = -568
            else if (i == 9) text.y = -575
            else text.y = -540;
            temp = text.x;

            this.historyHeaderContainer.addChild(text);
        }
        this.mask2.width = 1200
        this.historyContainer.addChild(this.historyHeaderContainer);
        this.betHistoryActive.addChild(this.mask2);
        this.historyHeaderContainer.mask = this.mask2;
    }


    setupCloseButton() {
        this.closeButtonNormal = new PIXI.Sprite(PIXI.Assets.get('close_b_normal'));
        this.closeButtonNormal.anchor.set(0.5);
        this.closeButtonNormal.scale.set(0.9);
        this.closeButtonNormal.position.set(1220, 705);
        this.closeButtonNormal.interactive = true;
        this.closeButtonNormal.cursor = 'pointer'
        this.backgroundBlur.addChild(this.closeButtonNormal);

        const closeButtonHover = new PIXI.Sprite(PIXI.Assets.get('close_b_selected'));
        closeButtonHover.anchor.set(0.5);
        this.closeButtonNormal.addChild(closeButtonHover);
        closeButtonHover.visible = false;


        const closeButtonDown = new PIXI.Sprite(PIXI.Assets.get('close_b_selected'));
        closeButtonDown.anchor.set(0.5);
        this.closeButtonNormal.addChild(closeButtonDown);
        closeButtonDown.visible = false;


        this.closeButtonNormal.on('pointerdown', (event) => {
            if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') { closeButtonDown.visible = true; setTimeout(() => { closeButtonDown.visible = false; }, 200); globalData.isScroll = false; }
        });
        this.closeButtonNormal.on('pointerup', (event) => {
            if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
                instances.Meter.startPulsate(); this.disable();
                this.tutorialMenuActive.visible = false;
                this.settingsMenuActive.visible = true;
                this.betHistoryActive.visible = false;
            }
        });
        this.closeButtonNormal.on('pointerover', () => { closeButtonHover.visible = true });
        this.closeButtonNormal.on('pointerout', () => { closeButtonHover.visible = false });
    }
    settingsButton = new PIXI.Graphics();
    tutorialButton = new PIXI.Graphics();
    setupMenu() {

        // this.tutorialMenuInactive = new PIXI.Sprite(PIXI.Assets.get('tutorialInactive'));
        // this.tutorialMenuInactive.anchor.set(0.5);
        // this.tutorialMenuInactive.scale.set(1);
        // this.tutorialMenuInactive.x = config.logicalWidth / 2
        // this.tutorialMenuInactive.y = config.logicalHeight / 2
        // this.backgroundBlur.addChild(this.tutorialMenuInactive);


        // this.settingsMenuInactive = new PIXI.Sprite(PIXI.Assets.get('settingsInactive'));
        // this.settingsMenuInactive.anchor.set(0.5);
        // this.settingsMenuInactive.scale.set(1);
        // this.settingsMenuInactive.x = config.logicalWidth / 2
        // this.settingsMenuInactive.y = config.logicalHeight / 2
        // this.backgroundBlur.addChild(this.settingsMenuInactive);

        // this.settingsMenuInactive.interactive = true;
        // this.settingsMenuInactive.on('pointerdown', () => { this.enableSettingsMenu() });

        this.settingsMenuActive = new PIXI.Sprite(PIXI.Assets.get('diag_settings'));
        this.settingsMenuActive.anchor.set(0.5);
        this.settingsMenuActive.scale.set(0.85);
        this.settingsMenuActive.x = config.logicalWidth / 2
        this.settingsMenuActive.y = config.logicalHeight / 2
        this.backgroundBlur.addChild(this.settingsMenuActive);
        this.setupSettingsMenu();

        this.tutorialMenuActive = new PIXI.Sprite(PIXI.Assets.get('diag_tutorial'));
        this.tutorialMenuActive.anchor.set(0.5);
        this.tutorialMenuActive.scale.set(0.85);
        this.tutorialMenuActive.x = config.logicalWidth / 2
        this.tutorialMenuActive.y = config.logicalHeight / 2
        this.backgroundBlur.addChild(this.tutorialMenuActive);

        this.betHistoryActive = new PIXI.Sprite(PIXI.Assets.get('diag_bethistory'));
        this.betHistoryActive.anchor.set(0.5);
        this.betHistoryActive.visible = false;
        this.betHistoryActive.scale.set(0.85);
        this.betHistoryActive.x = config.logicalWidth / 2
        this.betHistoryActive.y = config.logicalHeight / 2
        this.backgroundBlur.addChild(this.betHistoryActive);

        const tutorialButton = new PIXI.Graphics();
        tutorialButton.beginFill(0, 0.01);
        tutorialButton.drawRect(config.logicalWidth / 2 - 175, config.logicalHeight / 2 - 790, 350, 100);
        tutorialButton.endFill();
        tutorialButton.interactive = true;
        tutorialButton.cursor = 'pointer'
        tutorialButton.on('pointerdown', (event) => {
            if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') { this.enableTutorialMenu() }
        });
        this.backgroundBlur.addChild(tutorialButton);

        const settingsButton = new PIXI.Graphics();
        settingsButton.beginFill(0, 0.01);
        settingsButton.drawRect(config.logicalWidth / 2 - 560, config.logicalHeight / 2 - 800, 350, 100);
        settingsButton.endFill();
        settingsButton.interactive = true;
        settingsButton.cursor = 'pointer'
        settingsButton.on('pointerdown', (event) => {
            if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') { this.enableSettingsMenu(); globalData.isScroll = false }
        });
        this.backgroundBlur.addChild(settingsButton);

        const betHistoryButton = new PIXI.Graphics();
        betHistoryButton.beginFill(0, 0.01);
        betHistoryButton.drawRect(config.logicalWidth / 2 + 200, config.logicalHeight / 2 - 800, 350, 100);
        betHistoryButton.endFill();
        betHistoryButton.interactive = true;
        betHistoryButton.cursor = 'pointer'
        betHistoryButton.on('pointerdown', (event) => {
            if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') { this.enableBetHistory(); globalData.isScroll = false; betHistory() }
        });
        this.backgroundBlur.addChild(betHistoryButton);

    }
    setupSettingsMenu() {
        this.setupVersionNumber();
        this.setupSoundButton(-400, -360);
        this.setupMusicButton(0, -360);
        this.setupVibrateButton(400, -360);
        if (globalData.gameLanguage) this.setupBlueButtons(0, -85);
        this.setupFpsButton(0, 550);

        // this.setupTestApiButton();
    }
    setupTutorialMenu(page = [], flag = false) {
        this.setupMask();
        this.setupArrow()
        if (flag) {
            this.stopPos = -4690
            this.prizePos = -500
            globalData.tutorialLast = -4695;
            this.setuptagalogPageContents(page)
        } else {
            this.stopPos = -3645;
            this.prizePos = -520;
            globalData.tutorialLast = -3650
            this.setupPageContents(page);
        }
        this.setupPagination();
    }

    setupTestApiButton() {
        // const apiButton = new PIXI.Sprite(PIXI.Assets.get('api'));
        // apiButton.anchor.set(0.5);
        // apiButton.scale.set(0.5);
        // apiButton.x = 0
        // apiButton.y = 0
        // this.settingsMenuActive.addChild(apiButton);
        // apiButton.interactive = true 
        // apiButton.on('pointerdown', () => { playGame()});;
    }

    setupBlueButtons(x, y) {

        const languageText = new PIXI.Sprite(PIXI.Assets.get('lang'))
        languageText.anchor.set(0.5);
        languageText.scale.set(1.55);
        languageText.x = x;
        languageText.y = y;
        this.settingsMenuActive.addChild(languageText)


        const toggle1Container = new PIXI.Container();
        const toggle2Container = new PIXI.Container();

        const langEnglishSelect = new PIXI.Sprite(PIXI.Assets.get('lang_english_select'))
        const langEnglishNonSelect = new PIXI.Sprite(PIXI.Assets.get('lang_english_nonselect'))

        const langTagalogSelect = new PIXI.Sprite(PIXI.Assets.get('lang_tagalog_select'))
        const langTagalogNonSelect = new PIXI.Sprite(PIXI.Assets.get('lang_tagalog_nonselect'))

        let currentActiveLanguage = langEnglishSelect

        toggle1Container.y = y + 130
        toggle1Container.x = x
        toggle1Container.pivot.x = toggle1Container.width / 2
        toggle1Container.scale.set(1.4)
        toggle2Container.scale.set(1.4)

        langEnglishNonSelect.visible = false
        langEnglishSelect.visible = true

        langEnglishSelect.x = -langEnglishSelect.width / 2
        langEnglishNonSelect.x = -langEnglishNonSelect.width / 2

        toggle1Container.interactive = true;
        toggle1Container.buttonMode = true;
        toggle1Container.cursor = 'pointer'

        toggle1Container.addChild(langEnglishSelect)
        toggle1Container.addChild(langEnglishNonSelect)

        toggle1Container.on('pointerdown', (event) => {
            if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {

                if (currentActiveLanguage === langEnglishSelect) return;

                setLanguage('en')

                langEnglishNonSelect.visible = false;
                langEnglishSelect.visible = true;
                currentActiveLanguage = langEnglishSelect;
                langTagalogNonSelect.visible = true;
                langTagalogSelect.visible = false;

                this.setupTutorialMenu(globalData.isJackpotActive ? this.withJackpotEng : this.withoutJackpotEng);
            }
        })

        toggle2Container.y = toggle1Container.y + 205
        toggle2Container.x = x
        toggle2Container.pivot.x = toggle2Container.width / 2

        langTagalogNonSelect.visible = true
        langTagalogSelect.visible = false

        langTagalogSelect.x = -langTagalogSelect.width / 2;
        langTagalogNonSelect.x = -langTagalogNonSelect.width / 2;

        toggle2Container.interactive = true
        toggle2Container.buttonMode = true
        toggle2Container.cursor = 'pointer'

        toggle2Container.addChild(langTagalogSelect)
        toggle2Container.addChild(langTagalogNonSelect)

        //TODO: FLAG
        toggle2Container.on('pointerdown', (event) => {
            if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {

                if (currentActiveLanguage === langTagalogSelect) return;

                setLanguage('tl')

                langTagalogNonSelect.visible = false;
                langTagalogSelect.visible = true;
                currentActiveLanguage = langTagalogSelect;
                langEnglishNonSelect.visible = true;
                langEnglishSelect.visible = false;

                this.setupTutorialMenu(
                    globalData.isJackpotActive ? this.withJackpotTag : this.withoutJackpotTag,
                    true
                );
            }
        })
        this.settingsMenuActive.addChild(toggle1Container, toggle2Container)

        setTimeout(() => {

            if (globalData.gameLanguage === "en") {

                langEnglishNonSelect.visible = false;
                langEnglishSelect.visible = true;
                currentActiveLanguage = langEnglishSelect;
                langTagalogNonSelect.visible = true;
                langTagalogSelect.visible = false;

                this.setupTutorialMenu(globalData.isJackpotActive ? this.withJackpotEng : this.withoutJackpotEng);
            } else {
                langTagalogNonSelect.visible = false;
                langTagalogSelect.visible = true;
                currentActiveLanguage = langTagalogSelect;
                langEnglishNonSelect.visible = true;
                langEnglishSelect.visible = false;

                this.setupTutorialMenu(
                    globalData.isJackpotActive ? this.withJackpotTag : this.withoutJackpotTag,
                    true
                );
            }
        }, 500);

    }

    setupSoundButton(x, y) {
        const soundButton = new PIXI.Sprite(PIXI.Assets.get('soundNormal'));
        soundButton.anchor.set(0.5);
        soundButton.scale.set(1.25);
        soundButton.x = x
        soundButton.y = y
        soundButton.cursor = 'pointer'
        soundButton.interactive = true
        this.settingsMenuActive.addChild(soundButton);

        const hover = new PIXI.Sprite(PIXI.Assets.get('soundHover'));
        hover.anchor.set(0.5);
        soundButton.addChild(hover);
        hover.visible = false;

        const disable = new PIXI.Sprite(PIXI.Assets.get('soundDisable'));
        disable.anchor.set(0.5);
        soundButton.addChild(disable);
        disable.visible = false;

        soundButton.on('pointerdown', (event) => {
            if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
                if (disable.visible) {
                    disable.visible = false
                    // globalVolumes(1);
                    globalData.sounds = true;
                    stopSFX(disable.visible)
                }
                else {
                    disable.visible = true
                    // globalVolumes(0);
                    stopSFX(disable.visible)
                    globalData.sounds = true;
                }
            }
        });
        soundButton.on('pointerover', () => {
            hover.visible = true;
        });
        soundButton.on('pointerout', () => {
            hover.visible = false;
        });
    }

    setupMusicButton(x, y) {
        const musicButton = new PIXI.Sprite(PIXI.Assets.get('musicNormal'));
        musicButton.anchor.set(0.5);
        musicButton.scale.set(1.25);
        musicButton.x = x
        musicButton.y = y
        musicButton.interactive = true
        musicButton.cursor = 'pointer'
        this.settingsMenuActive.addChild(musicButton);

        const hover = new PIXI.Sprite(PIXI.Assets.get('musicHover'));
        hover.anchor.set(0.5);
        musicButton.addChild(hover);
        hover.visible = false;

        const disable = new PIXI.Sprite(PIXI.Assets.get('musicDisable'));
        disable.anchor.set(0.5);
        musicButton.addChild(disable);
        disable.visible = false;

        musicButton.on('pointerdown', (event) => {
            if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
                if (disable.visible) {
                    disable.visible = false
                    //    globalVolumes(1);
                    playMainBg()

                }
                else {
                    disable.visible = true
                    //   globalVolumes(0);
                    stopMainBg()
                }
            }
        });
        musicButton.on('pointerover', () => {
            hover.visible = true;
        });
        musicButton.on('pointerout', () => {
            hover.visible = false;
        });
    }
    setupFpsButton(x, y) {
        const fpsButton = new PIXI.Sprite(PIXI.Assets.get('fpsEnabled'));
        fpsButton.anchor.set(0.5);
        fpsButton.scale.set(0.35);
        fpsButton.x = x
        fpsButton.y = y
        fpsButton.interactive = true
        this.settingsMenuActive.addChild(fpsButton);

        const hover = new PIXI.Sprite(PIXI.Assets.get('fpsEnabled'));
        hover.anchor.set(0.5);
        // hover.scale.set(0.5);
        fpsButton.addChild(hover);
        hover.visible = false;

        const disable = new PIXI.Sprite(PIXI.Assets.get('fpsDisabled'));
        disable.anchor.set(0.5);
        //  disable.scale.set(0.5);
        fpsButton.addChild(disable);
        disable.visible = false;

        fpsButton.on('pointerdown', (event) => {
            if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
                if (disable.visible) {
                    disable.visible = false
                    //    globalVolumes(1);
                    this.hideMainBg()

                }
                else {
                    disable.visible = true
                    //   globalVolumes(0);
                    this.showMainBg()
                }
            }
        });
        fpsButton.on('pointerover', () => {
            hover.visible = true;
        });
        fpsButton.on('pointerout', () => {
            hover.visible = false;
        });
    }
    hideMainBg() {
        // if (globalData.stats.visible) {
        document.body.removeChild(globalData.stats.dom); // Remove FPS meter
        globalData.stats.visible = false; // Set the visibility flag to false
        // } else {
        //document.body.appendChild(globalData.stats.dom); // Add FPS meter
        // globalData.stats.visible = true; // Set the visibility flag to true
        // }
    }
    showMainBg() {
        // if (globalData.stats.visible) {
        //   document.body.removeChild(globalData.stats.dom); // Remove FPS meter
        //   globalData.stats.visible = false; // Set the visibility flag to false
        // } else {
        document.body.appendChild(globalData.stats.dom); // Add FPS meter
        globalData.stats.visible = true; // Set the visibility flag to true
        // }
    }
    setupVibrateButton(x, y) {
        const vibrateButton = new PIXI.Sprite(PIXI.Assets.get('vibrateNormal'));
        vibrateButton.anchor.set(0.5);
        vibrateButton.scale.set(1.25);
        vibrateButton.x = x
        vibrateButton.y = y
        vibrateButton.cursor = 'pointer'
        vibrateButton.interactive = true
        this.settingsMenuActive.addChild(vibrateButton);

        const hover = new PIXI.Sprite(PIXI.Assets.get('vibrateHover'));
        hover.anchor.set(0.5);
        vibrateButton.addChild(hover);
        hover.visible = false;

        const disable = new PIXI.Sprite(PIXI.Assets.get('vibrateDisable'));
        disable.anchor.set(0.5);
        vibrateButton.addChild(disable);
        disable.visible = false;

        vibrateButton.on('pointerdown', (event) => {
            if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
                if (disable.visible) {
                    disable.visible = false
                    globalData.vibration = true
                }
                else {
                    disable.visible = true
                    globalData.vibration = false
                }
            }
        });
        vibrateButton.on('pointerover', () => {
            hover.visible = true;
        });
        vibrateButton.on('pointerout', () => {
            hover.visible = false;
        });
    }


    setupVersionNumber() {
        const style = new PIXI.TextStyle({
            dropShadow: false,
            dropShadowAngle: 0,
            dropShadowBlur: 0,
            dropShadowColor: 0,
            dropShadowDistance: 0,
            stroke: 0,
            strokeThickness: 0,
            fill: '#999999',
            fontFamily: 'Arial',
            fontSize: 35,
            fontWeight: '500',
            align: 'center'
        });

        const versionText = new PIXI.Text('Version Number ' + globalData.version, style);
        versionText.y = this.settingsMenuActive.height / 2 - 30
        versionText.x = 0
        versionText.anchor.set(0.5);
        versionText.scale.set(1.7)
        this.settingsMenuActive.addChild(versionText);
    }
    mask = null;
    setupMask() {
        this.mask = new PIXI.Sprite(PIXI.Assets.get('gameScreen'));
        this.mask.anchor.set(0.5);
        this.mask.scale.set(1.35);
        this.mask.alpha = 1
        this.mask.name = "masksks"
        this.mask.x = 0
        this.mask.y = 80
        this.mask.width = 1200
        this.tutorialMenuActive.addChild(this.mask);
        //this.tutorialMenuActive.mask = this.mask
    }
    startPointerY = 0
    startContainerY = 0
    pointerDown = false

    setupArrow() {
        if (this.arrow) return;

        this.arrow = new PIXI.Sprite(PIXI.Assets.get('scrollArrow'));
        this.arrow.anchor.set(0.5);
        this.arrow.scale.set(2);
        this.arrow.y = 890;
        this.arrow.interactive = true;
        this.arrow.cursor = 'pointer'
        this.arrow.visible = false;
        this.arrow.zIndex = 1000

        this.tutorialMenuActive.addChild(this.arrow);

        this.arrow.on('pointerdown', () => {
            this.arrow.visible = false;

            if (this.currentPage == 2) {
                globalData.prizeScroll = true;
            } else {
                globalData.isScroll = true;
            }
        });

        gsap.timeline({ repeat: -1, yoyo: true })
            .to(this.arrow, {
                pixi: {
                    scale: 2.7
                },
                duration: 0.3,
                ease: "power1.inOut",
            });
    }

    scrollPrize(delta) {
        this.page[2].y = this.page[2].y - delta * 3;

        if (this.page[2].y < this.prizePos) {
            globalData.prizeScroll = false;
        }
    }

    scrollPage(delta) {
        this.page[this.page.length - 1].y = this.page[this.page.length - 1].y - delta * 3;
        if (this.page[this.page.length - 1].y < this.stopPos) {
            globalData.isScroll = false;
        }
    }

    setupPageContents(page) {
        // globalData.isJackpotActive = false
        // console.log("rrrr english",globalData.isJackpotActive);
        const pageSpriteKey = page;
        if (this.pageContainer) {
            this.pageContainer.removeChildren();
        } else {
            this.pageContainer = new PIXI.Container();
        }

        this.pageContainer.interactive = true;
        this.pageContainer.mask = this.mask;
        this.size = 11
        if (globalData.isJackpotActive) {
            this.size = 12
        }
        for (let pageNumber = 0; pageNumber < this.size; pageNumber++) {

            this.page[pageNumber] = new PIXI.Container();
            if (pageNumber < this.size - 1) {
                const pageSprite = new PIXI.Sprite(PIXI.Assets.get(pageSpriteKey[pageNumber] + "_content"));
                pageSprite.anchor.set(0.5);

                if (pageNumber == 0) {
                    this.page[pageNumber].y = 10
                    this.page[pageNumber].scale.set(1.12)
                }
                if (pageNumber === 2) {
                    const scrollContainer = this.page[pageNumber];

                    scrollContainer.interactive = true;
                    scrollContainer.cursor = 'grab';
                    scrollContainer.scale.set(1);
                    scrollContainer.y = 680;

                    const mask = this.mask;

                    const visibleTopY = 650;
                    const visibleHeight = mask.height;
                    const contentHeight = pageSprite.height;
                    const minY = visibleTopY - (contentHeight - visibleHeight);

                    const maxY = 780;


                    scrollContainer.on('pointerdown', (event) => {
                        if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
                            gameAssets.pointerDown = true;
                            gameAssets.startPointerY = event.data.global.y;
                            gameAssets.startContainerY = scrollContainer.y;
                        }
                    });

                    scrollContainer.on('pointermove', (event) => {
                        if (gameAssets.pointerDown) {
                            const currentPointerY = event.data.global.y;
                            const deltaY = currentPointerY - gameAssets.startPointerY;

                            let newY = gameAssets.startContainerY + deltaY;

                            // Enforce scroll bounds
                            if (newY > maxY) newY = maxY;
                            if (newY < minY) newY = minY;

                            scrollContainer.y = newY;
                            if (this.page[2].y < -510) {
                                globalData.prizeScroll = false;
                                this.arrow.visible = false;
                            } else {
                                globalData.prizeScroll = false;
                                this.arrow.visible = true;
                            }
                        }
                    });

                    scrollContainer.on('pointerup', () => {
                        gameAssets.pointerDown = false;
                    });

                    scrollContainer.on('pointerupoutside', () => {
                        gameAssets.pointerDown = false;
                    });
                }

                if (pageNumber === 1) {
                    this.page[pageNumber].x = -10
                    this.page[pageNumber].scale.set(1.1)
                }

                if (pageNumber === 4) {
                    pageSprite.x = -30
                    this.page[pageNumber].y = 85
                    this.page[pageNumber].scale.set(1.15)
                }

                if (pageNumber === 5) {
                    this.page[pageNumber].x = -15;
                    this.page[pageNumber].scale.set(1.27)
                    this.page[pageNumber].y = 70
                }

                if (pageNumber === 6) {
                    pageSprite.x = 0
                    pageSprite.y = 40
                    this.page[pageNumber].scale.set(2.2)
                }

                if (pageNumber == 7) {
                    this.page[pageNumber].scale.set(1.3)

                }

                if (pageNumber === 8) {
                    this.page[pageNumber].y = globalData.isJackpotActive ? 110 : 0
                    this.page[pageNumber].scale.set(globalData.isJackpotActive ? 0.8 : 1.3)
                }

                if (pageNumber == 9) {
                    if (globalData.isJackpotActive) {
                        this.page[pageNumber].scale.set(1.35)
                    } else {
                        this.page[pageNumber].scale.set(1)
                    }
                }

                if (pageNumber === 3) {
                    this.page[pageNumber].x = 5
                    this.page[pageNumber].scale.set(1)
                }
                if (pageNumber !== 2 && pageNumber !== 6) {
                    pageSprite.y = 68
                    pageSprite.scale.set(2)
                }
                this.page[pageNumber].addChild(pageSprite);
                this.page[pageNumber].visible = false;
            }
            else {
                if (!globalData.showAutoAndTurbo) {
                    const pageSprite1 = new PIXI.Sprite(PIXI.Assets.get('p8_content_without_auto'));
                    pageSprite1.anchor.set(0.5);
                    pageSprite1.scale.set(2.6);
                    this.page[pageNumber].y = 90;

                    this.page[pageNumber].addChild(pageSprite1);
                    this.page[pageNumber].visible = false;
                    this.page[pageNumber].mask = this.mask;
                } else {
                    const pageSprite1 = new PIXI.Sprite(PIXI.Assets.get('p7_new_content_EN'));
                    pageSprite1.anchor.set(0.5);
                    pageSprite1.scale.set(2.75);
                    pageSprite1.y = 1500;

                    this.page[pageNumber].addChild(pageSprite1);
                    this.page[pageNumber].visible = false;
                    this.page[pageNumber].interactive = true;
                    this.page[pageNumber].mask = this.mask;
                    this.page[pageNumber].y = 795;

                    // Define scroll bounds
                    const minY = -pageSprite1.y - pageSprite1.height + this.mask.height + 2300; // Bottom bound
                    const maxY = 795; // Top bound

                    const updateCursor = () => {
                        if (this.page[pageNumber].y > minY && this.page[pageNumber].y < maxY) {
                            this.page[pageNumber].cursor = 'grab'; // Scrollable, show grab cursor
                        } else {
                            this.page[pageNumber].cursor = 'default'; // Not scrollable, default cursor
                        }
                    };

                    // Pointer down event
                    this.page[pageNumber].on('pointerdown', (event) => {
                        if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
                            this.pointerDown = true;
                            const self = event.currentTarget;
                            const index = this.page.indexOf(self);
                            this.startPointerY = event.data.global.y; // Record pointer position
                            this.startContainerY = this.page[index].y; // Record container's position
                            updateCursor();
                        }
                    });

                    // Pointer move event
                    this.page[pageNumber].on('pointermove', (event) => {
                        if (this.pointerDown) {
                            const self = event.currentTarget;
                            const index = this.page.indexOf(self);
                            const currentPointerY = event.data.global.y;
                            const deltaY = currentPointerY - this.startPointerY;

                            // Calculate new position
                            let newY = this.startContainerY + deltaY;

                            // Enforce bounds
                            if (newY > maxY) newY = maxY; // Top bound
                            if (newY < minY) newY = minY; // Bottom bound

                            // Update position
                            this.page[index].y = newY;
                            if (this.page[this.page.length - 1].y < globalData.tutorialLast) {
                                this.arrow.visible = false;
                            } else {
                                this.arrow.visible = true;
                            }
                            globalData.isScroll = false;
                            updateCursor();
                        }
                    });

                    // Pointer up event to stop dragging
                    this.page[pageNumber].on('pointerup', () => {
                        this.pointerDown = false;
                    });

                    // Pointer out event to stop dragging
                    this.page[pageNumber].on('pointerout', () => {
                        this.pointerDown = false;
                    });
                }
            }
            this.pageContainer.addChild(this.page[pageNumber]);
        }
        this.tutorialMenuActive.addChild(this.pageContainer);
    }

    setuptagalogPageContents(page) {
        // globalData.isJackpotActive = false
        // console.log("rrrr taglog",globalData.isJackpotActive);
        this.size = 11
        if (globalData.isJackpotActive) {
            this.size = 12
        }
        const pageSpriteKey = page;
        if (this.pageContainer) {
            this.pageContainer.removeChildren();
        } else {
            this.pageContainer = new PIXI.Container();
        }
        this.pageContainer.interactive = true;
        this.pageContainer.mask = this.mask;
        for (let pageNumber = 0; pageNumber < this.size; pageNumber++) {
            this.page[pageNumber] = new PIXI.Container();
            if (pageNumber < this.size - 1) {
                const pageSprite = new PIXI.Sprite(PIXI.Assets.get(pageSpriteKey[pageNumber]));
                pageSprite.anchor.set(0.5);

                if (pageNumber == 0) {
                    this.page[pageNumber].scale.set(1.12)
                    this.page[pageNumber].y = 0
                } else if (pageNumber == 1) {
                    this.page[pageNumber].y = 105
                    this.page[pageNumber].scale.set(0.63)
                } else if (pageNumber == 3) {
                    this.page[pageNumber].scale.set(1.35)
                    this.page[pageNumber].x = -105
                    this.page[pageNumber].y = 70
                } else if (pageNumber === 4) {
                    this.page[pageNumber].x = -60
                    this.page[pageNumber].y = 5
                    this.page[pageNumber].scale.set(1.35)
                }
                else if (pageNumber == 2) {
                    this.page[pageNumber].y = 240
                    pageSprite.scale.set(1.02)
                } else if (pageNumber == 5) {
                    this.page[pageNumber].y = -20
                    this.page[pageNumber].x = -30
                    this.page[pageNumber].scale.set(1.45)
                } else if (pageNumber == 6) {
                    this.page[pageNumber].y = 110
                    this.page[pageNumber].x = 0
                    this.page[pageNumber].scale.set(1.1)
                } else if (pageNumber === 8) {
                    this.page[pageNumber].y = globalData.isJackpotActive ? 70 : 20
                    this.page[pageNumber].scale.set(globalData.isJackpotActive ? 0.83 : 1)
                } else if (pageNumber === 9) {
                    if (globalData.isJackpotActive) {
                        this.page[pageNumber].y = 0
                        this.page[pageNumber].scale.set(1)
                    } else {

                        this.page[pageNumber].y = 0
                        this.page[pageNumber].scale.set(1.2)
                    }
                } else if (pageNumber == 10) {
                    this.page[pageNumber].scale.set(1.2)
                }
                else if (pageNumber == 7) {
                    this.page[pageNumber].scale.set(1.22)
                }

                if (pageNumber === 2) {
                    const container = this.page[pageNumber];
                    container.interactive = true;
                    container.cursor = 'grab';
                    container.y = 980;

                    const maskHeight = this.mask.height;
                    const contentHeight = pageSprite.height * pageSprite.scale.y;

                    const maxY = 980;
                    const minY = 950 - (contentHeight - maskHeight); // Correct scrolling boundary

                    let dragging = false;
                    let startPointerY = 0;
                    let startY = 0;

                    container.on('pointerdown', (event) => {
                        dragging = true;
                        startPointerY = event.data.global.y;
                        startY = container.y;
                    });

                    container.on('pointermove', (event) => {
                        if (dragging) {
                            const deltaY = event.data.global.y - startPointerY;
                            let newY = startY + deltaY;
                            newY = Math.min(Math.max(newY, minY), maxY);
                            container.y = newY;

                            if (this.page[2].y < -590) {
                                globalData.prizeScroll = false;
                                this.arrow.visible = false;
                            } else {
                                this.arrow.visible = true;
                                globalData.prizeScroll = false;
                            }
                        }
                    });

                    container.on('pointerup', () => {
                        dragging = false;
                    });

                    container.on('pointerupoutside', () => {
                        dragging = false;
                    });
                }

                if (pageNumber == 4) pageSprite.x = 60
                if (pageNumber === 3) pageSprite.x = 80
                if (pageNumber !== 2) {
                    pageSprite.y = 68
                    pageSprite.scale.set(2)
                }
                this.page[pageNumber].addChild(pageSprite);
                this.page[pageNumber].visible = false;
            } else {
                if (!globalData.showAutoAndTurbo) {
                    const pageSprite1 = new PIXI.Sprite(PIXI.Assets.get('p8_content_ph_without_auto'));
                    pageSprite1.anchor.set(0.5);
                    pageSprite1.scale.set(2.6);

                    this.page[pageNumber].addChild(pageSprite1);
                    this.page[pageNumber].visible = false;
                    this.page[pageNumber].y = 80;
                    this.page[pageNumber].mask = this.mask;
                } else {

                    const pageSprite1 = new PIXI.Sprite(PIXI.Assets.get('p7_new_content_PH'));
                    pageSprite1.anchor.set(0.5);
                    pageSprite1.scale.set(2.9);
                    pageSprite1.y = 2255;

                    this.page[pageNumber].addChild(pageSprite1);
                    this.page[pageNumber].visible = false;
                    this.page[pageNumber].interactive = true;
                    this.page[pageNumber].mask = this.mask;
                    this.page[pageNumber].y = 400;

                    const minY = -pageSprite1.y - pageSprite1.height + this.mask.height + 2710
                    const maxY = 400;
                    let dragging = false
                    let startPointerY = 0;
                    let startY = 0;

                    const updateCursor = () => {
                        if (this.page[pageNumber].y > minY && this.page[pageNumber].y < maxY) {
                            this.page[pageNumber].cursor = 'grab';
                        } else {
                            this.page[pageNumber].cursor = 'default';
                        }
                    };

                    this.page[pageNumber].on('pointerdown', (event) => {
                        dragging = true;
                        startPointerY = event.data.global.y;
                        startY = this.page[pageNumber].y;
                        this.page[pageNumber].cursor = 'grabbing';
                    });

                    this.page[pageNumber].on('pointermove', (event) => {
                        if (dragging) {
                            const deltaY = event.data.global.y - startPointerY;
                            let newY = startY + deltaY;
                            newY = Math.min(Math.max(newY, minY), maxY);
                            this.page[pageNumber].y = newY;
                            updateCursor();
                            if (this.page[this.page.length - 1].y < globalData.tutorialLast) {
                                this.arrow.visible = false;
                            } else {
                                this.arrow.visible = true;
                            }
                            globalData.isScroll = false;
                        }
                    });

                    this.page[pageNumber].on('pointerup', () => {
                        dragging = false;
                        updateCursor();
                    });

                    this.page[pageNumber].on('pointerupoutside', () => {
                        dragging = false;
                        updateCursor();
                    });

                    updateCursor();
                }
            }
            this.pageContainer.addChild(this.page[pageNumber]);
        }
        this.tutorialMenuActive.addChild(this.pageContainer);
    }



    pageIcons = [];
    currentPage = 0;
    setupPagination() {
        this.size = 11
        if (globalData.isJackpotActive) {
            this.size = 12
        }
        for (let points = 0; points < this.size; points++) {
            this.pageIcons[points] = new PIXI.Sprite(PIXI.Assets.get('tutorialNormal'));
            if (globalData.isJackpotActive) {
                this.pageIcons[points].x = points * 115 - 620;
            } else {
                this.pageIcons[points].x = points * 125 - 620;
            }
            this.pageIcons[points].y = this.tutorialMenuActive.height / 2 + 245
            this.pageIcons[points].anchor.set(0.5)
            this.pageIcons[points].interactive = true;

            const selected = new PIXI.Sprite(PIXI.Assets.get('tutorialSelected'));
            selected.anchor.set(0.5)
            selected.visible = false;
            this.pageIcons[points].addChild(selected);

            this.pageIcons[points].on('pointerdown', (event) => {
                if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
                    var self = event.currentTarget
                    var index = this.pageIcons.indexOf(self)
                    this.pageIcons[index].children[0].visible = true;
                    this.currentPage = index;
                    this.showPage(this.currentPage);
                    playPlus();
                    if (index === this.size - 1 && globalData.showAutoAndTurbo && (this.page[this.page.length - 1].y > globalData.tutorialLast)) this.arrow.visible = true;
                    else if (index === 2 && this.page[2].y > this.prizePos) this.arrow.visible = true;
                    else {
                        globalData.isScroll = false;
                        this.arrow.visible = false;
                    }
                }
            });

            this.tutorialMenuActive.addChild(this.pageIcons[points]);
        }
        const nextButton = new PIXI.Sprite(PIXI.Assets.get('rightNormal'));
        nextButton.anchor.set(0.5)
        nextButton.x = this.pageIcons[this.pageIcons.length - 1].x + 120;
        nextButton.y = this.tutorialMenuActive.height / 2 + 245
        nextButton.interactive = true;
        const nextHover = new PIXI.Sprite(PIXI.Assets.get('rightHover'));
        nextHover.anchor.set(0.5)
        nextButton.addChild(nextHover);
        nextHover.visible = false;
        nextButton.cursor = 'pointer'

        nextButton.on('pointerdown', (event) => {
            if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
                if (this.currentPage < this.size - 1) {
                    this.showPage(++this.currentPage);
                    playPlus()
                    if (this.currentPage === this.size - 1 && globalData.showAutoAndTurbo && (this.page[this.page.length - 1].y > globalData.tutorialLast)) {
                        this.arrow.visible = true;
                    } else if (this.currentPage == 2 && this.page[2].y > -500) {
                        this.arrow.visible = true;
                    } else {
                        this.arrow.visible = false;
                    }

                }
                else {
                    playDisable();
                }
            }
        })

        nextButton.on("pointerover", () => {
            nextHover.visible = true;
        })
        nextButton.on("pointerout", () => {
            nextHover.visible = false;
        })

        const backButton = new PIXI.Sprite(PIXI.Assets.get('leftNormal'));
        backButton.anchor.set(0.5)
        backButton.x = this.pageIcons[0].x - 120
        backButton.y = this.tutorialMenuActive.height / 2 + 245
        backButton.interactive = true;
        const backHover = new PIXI.Sprite(PIXI.Assets.get('leftHover'));
        backHover.anchor.set(0.5)
        backButton.addChild(backHover);
        backHover.visible = false;
        backButton.cursor = 'pointer'

        backButton.on('pointerdown', (event) => {
            if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
                if (this.currentPage > 0) {
                    this.showPage(--this.currentPage);
                    playMinus();

                    if (this.currentPage == 2 && this.page[2].y > this.prizePos) {
                        this.arrow.visible = true;
                    } else {
                        this.arrow.visible = false;
                    }
                    globalData.isScroll = false;
                }
                else {
                    playDisable();
                }
            }
        })

        backButton.on("pointerover", () => {
            backHover.visible = true;
        })
        backButton.on("pointerout", () => {
            backHover.visible = false;
        })

        this.tutorialMenuActive.addChild(nextButton, backButton);
        this.showPage(this.currentPage);
    }

    showPage(index) {
        for (let pageNumber = 0; pageNumber < this.size; pageNumber++) {
            this.page[pageNumber].visible = false;
            this.pageIcons[pageNumber].children[0].visible = false;
        }
        this.pageIcons[index].children[0].visible = true;
        this.page[index].visible = true;
    }


    enableSettingsMenu() {
        this.settingsMenuActive.visible = true;
        // this.tutorialMenuInactive.visible = true;
        this.tutorialMenuActive.visible = false;
        this.betHistoryActive.visible = false;
        // this.settingsMenuInactive.visible = false;
        this.settingsButton.interactive = false;
        this.tutorialButton.interactive = true;
        playtabChange()
    }

    enableBetHistory() {
        this.settingsMenuActive.visible = false;
        this.tutorialMenuActive.visible = false;
        this.betHistoryActive.visible = true;
        playtabChange()
        // this.settingsButton.interactive = false;
        // this.tutorialButton.interactive = false;

    }

    enableTutorialMenu() {
        this.settingsMenuActive.visible = false;
        this.betHistoryActive.visible = false;
        // this.tutorialMenuInactive.visible = false;
        this.tutorialMenuActive.visible = true;
        // this.settingsMenuInactive.visible = true;
        this.settingsButton.interactive = true;
        this.tutorialButton.interactive = false;
        playtabChange()
    }



    enable() {
        gameAssets.gameUI.visible = false;
        gameAssets.gameUI.alpha = 0;
        this.menuPopUp.visible = true;
    }
    disable() {
        updateGameSpeed(false, true);
        this.menuPopUp.visible = false;
        gameAssets.gameUI.visible = true;
        gameAssets.gameUI.alpha = 1;
        playPopUpClose();
        gameAssets.menubarButton.alpha = 1;
        gameAssets.menubarButton.tint = 0xffffff
        gameAssets.menubarButton.interactive = true;
        instances.JackpotPanel.jackpotPanelSprite.visible = true
        if (globalData.currentGameState != gameStates.IDLE) {
            gameAssets.timer.visible = true
            gameAssets.timerTween.push(instances.SpinButton.startCircularTimer(gameAssets.timer))
        }
        //   console.log('popUp closed')
    }
}